import { SHOW_ALERT } from '../actions/alerts'

const initialState = {
    alert_message: {
        message: undefined,
        type: undefined,
    },
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SHOW_ALERT:
            return {
                ...state,
                alert_message: {
                    message: action.payload.message,
                    type: action.payload.type,
                },
            }
        default:
            return state
    }
}
